import React, { Suspense } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { UserProvider } from "./components/UserContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import ToastContainer from "./components/ui/ToastContainer";
import AppRoutes from "./routes/AppRoutes";
import RouteFallback from "./routes/RouteFallback";
import ScrollLock from "./routes/ScrollLock";

function App() {
  return (
    <ThemeProvider>
      <UserProvider>
        <Router
          future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
        >
          <ToastContainer />
          <ScrollLock />
          <Suspense fallback={<RouteFallback />}>
            <AppRoutes />
          </Suspense>
        </Router>
      </UserProvider>
    </ThemeProvider>
  );
}

export default App;
